// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__kKsBk","navList":"Nav_navList__1Fr-P","a":"Nav_a__3qO7d"};